import { combineReducers } from 'redux';
import authReducer from './auth';
import UserReducer from './UserReducer';
import ProfileReducer from './ProfileReducer';
import PublicationReducer from './PublicationReducer';
import ImageReducer from './ImageReducer';
import ProjectReducer from './ProjectReducer';
import ResearchAreaReducer from './ResearchAreaReducer';
import ProjectTimelineReducer from './ProjectTimelineReducer';
import IntakeReducer from './IntakeReducer';
import ProjectOverviewReducer from './ProjectOverviewReducer';
import MySupervisionsReducer from './MySupervisionsReducer';
import ExtensionRequestReducer from './ExtensionRequestReducer';
import AdminDashboardReducer from './AdminDashboardReducer';
import FileReducer from './FileReducer';
import ProjectTimelinesReducer from './ProjectTimelinesReducer';
import SupervisorReducer from './SupervisorReducer';
import SystemMessagesReducer from './SystemMessagesReducer';
import UserRoleReducer from './UserRoleReducer';
import EvaluationRubricsReducer from './EvaluationRubricsReducer';
import AdminSetupReducer from './AdminSetupReducers';
import ProjectVersionsHistoryReducer from './ProjectVersionsHistoryReducer';
import ConfigReducer from './ConfigReducer';
import localizationReducer from './localizationReducer';
import UniversityReducer from './UniversityReducer';
import FacultyReducer from './FacultyReducer';
import ProgramReducer from './ProgramReducer';
import archivedProjectsReducer from './archive/ArchivedProjectsReducer';
import currentArchivedProjectReducer from './archive/ArchivedCurrentProject';
import GradingReducer from './GradingReducer';
import departmentReducer from './DepartmentReducer';
import supervisorGroupReducer from './SupervisorGroupReducer';
import adminTextReducer from './AdminTextReducer';
import GradingSchemasReducer from './GradingSchemasReducer';
import BillingReducer from './billingReducer';
import invoiceReducer from './invoicesReducer';
import generalAppSettingsReducer from './settings/generalAppSettingsReducer';
import projectSettingsReducer from './settings/projectSettingsReducer';
import currentProjectTypeSettingsReducer from './settings/currentProjectSettingsReducer';
import emailTemplateReducer from './EmailTemplateReducer';
import versionReducer from './VersionReducer';
import selectedGradeReducer from './SelectedGradeReducer';

const reducers = combineReducers({
    auth: authReducer,
    adminTexts: adminTextReducer,
    users: UserReducer,
    publications: PublicationReducer,
    profile: ProfileReducer,
    images: ImageReducer,
    project: ProjectReducer,
    researchAreas: ResearchAreaReducer,
    intakes: IntakeReducer,
    university: UniversityReducer,
    faculties: FacultyReducer,
    programs: ProgramReducer,
    departments: departmentReducer,
    supervisorGroups: supervisorGroupReducer,
    projectTimeline: ProjectTimelineReducer,
    projectTimelines: ProjectTimelinesReducer,
    projectOverview: ProjectOverviewReducer,
    mySupervisions: MySupervisionsReducer,
    extensionRequest: ExtensionRequestReducer,
    adminDashboardData: AdminDashboardReducer,
    fileOfProof: FileReducer,
    supervisors: SupervisorReducer,
    systemMessages: SystemMessagesReducer,
    userRoles: UserRoleReducer,
    evaluationRubrics: EvaluationRubricsReducer,
    adminDocuments: AdminSetupReducer,
    projectVersionsHistory: ProjectVersionsHistoryReducer,
    configuration: ConfigReducer,
    localization: localizationReducer,
    archivedProjects: archivedProjectsReducer,
    currentArchivedProject: currentArchivedProjectReducer,
    grading: GradingReducer,
    gradingSchemas: GradingSchemasReducer,
    billing: BillingReducer,
    invoices: invoiceReducer,
    generalAppSettings: generalAppSettingsReducer,
    projectSettings: projectSettingsReducer,
    currentProjectTypeSettings: currentProjectTypeSettingsReducer,
    emailTemplates: emailTemplateReducer,
    version: versionReducer,
    selectedGrade: selectedGradeReducer,
});

export default reducers;

export type RootState = ReturnType<typeof reducers>;
